import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
// import { AppConfig } from "../app.config";
import { environment } from '../../environments/environment';


@Injectable()
export class CommonService {
  private rootUrl = "http://192.168.1.217:8000";

  constructor(private httpClient: HttpClient) {
    this.rootUrl = environment.API_URL
      ? environment.API_URL
      : this.rootUrl;
  }

  apiService(method, url, options) {
    let data = options ? options : {};
    switch (method) {
      case "POST":
        return this.httpClient.post(this.rootUrl + "/" + url, data, {});
      case "GET":
        return this.httpClient.get(this.rootUrl + "/" + url, {});
      case "DELETE":
        return this.httpClient.delete(this.rootUrl + "/" + url, {});
      default:
        return { status: false, message: "Method Not Allowed !." };
    }

  }
  apiServicePublicOrder(method, url, options) {
    let data = options ? options : {};
    var reqHeader = new HttpHeaders({ "No-Auth": "True" });
    return this.httpClient.get(this.rootUrl + "/" + url, { headers: reqHeader });

  }

  apifileData() {
    return this.httpClient.get('/assets/cartdata.json');
  }

  apiDashboardData() {
    return this.httpClient.get('/assets/dashboarddata.json');
  }

  downloadFile(data, header, filename = 'data') {
    let csvData = this.ConvertToCSV(data, header);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }

  SquareUpPayment(bodyPayload) {
    return this.httpClient.post(this.rootUrl + "/squareup/createPayment", bodyPayload)
  }

  removeProjectTitleStorage() {
    if (sessionStorage.length) {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith("projectTitle_")) {
          sessionStorage.removeItem(key);
        }
      }
    }
  }

  getIsConnectQBO () {
    let isConnectQBO = false;

    if (localStorage.getItem('userDetails')) {
      const getUserDetails = JSON.parse(localStorage.getItem('userDetails'));
      isConnectQBO = getUserDetails.hasOwnProperty('is_connect_qbo') ? getUserDetails.is_connect_qbo : false;
    }

    return isConnectQBO;
  }

  getPaymentHistory(payLoad) {
    return this.httpClient.post(this.rootUrl + "/invoice/paymentHistory", payLoad)
  }

  getRefundHistory(payLoad) {
    return this.httpClient.post(this.rootUrl + "/invoice/refundHistory", payLoad)
  }

  getEmailSentHistory(payLoad) {
    return this.httpClient.post(this.rootUrl + "/invoice/emailSentHistory", payLoad)
  }

  cloneOrder(payLoad) {
    return this.httpClient.post(this.rootUrl + "/order/clone", payLoad)
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_services/common.service.ts